<template>
  <el-dialog
    :visible.sync="visible"
    width="440px"
    :show-close="false"
    append-to-body
    :close-on-click-modal="false"
    custom-class="logout-confirm-dialog-shell"
    @closed="onClosed"
  >
    <div slot="title" class="lcd-title">
      <span class="lcd-warn-icon" aria-hidden="true">!</span>
      <span class="lcd-title-text">{{ titleText }}</span>
    </div>

    <div class="lcd-body">{{ bodyText }}</div>

    <span slot="footer" class="lcd-footer">
      <el-button class="lcd-btn-cancel" @click="handleCancel">取消</el-button>
      <el-button type="primary" class="lcd-btn-ok" @click="handleConfirm">确定</el-button>
      <el-button v-if="mode === 'all'" type="warning" class="lcd-btn-transfer" @click="handleConfirmTransfer">
        <span>确定并转接</span>
        <el-tooltip placement="top" effect="light" popper-class="lcd-transfer-tooltip" content="自动转接到可接待坐席，如果转接不成功，会话自动结束">
          <i class="el-icon-question lcd-btn-transfer-help" />
        </el-tooltip>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "LogoutConfirmDialog",
  data() {
    return {
      visible: false,
      /** device | all */
      mode: "device"
    };
  },
  computed: {
    titleText() {
      return this.mode === "device" ? "提示" : "退出所有设备登录状态";
    },
    bodyText() {
      return this.mode === "device" ? "确定退出当前设备登录状态吗？" : "确定退出所有设备登录状态吗？";
    }
  },
  methods: {
    /** @param {'device'|'all'} kind */
    open(kind) {
      this.mode = kind === "all" ? "all" : "device";
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    onClosed() {
      this.$emit("closed");
    },
    handleCancel() {
      this.close();
      this.$emit("cancel", { mode: this.mode });
    },
    handleConfirm() {
      const mode = this.mode;
      this.close();
      this.$emit("confirm", { mode });
    },
    handleConfirmTransfer() {
      const mode = this.mode;
      this.close();
      this.$emit("confirm-transfer", { mode });
    }
  }
};
</script>

<style scoped lang="scss">
.lcd-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 36px;
}

.lcd-warn-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff34d;
  color: #000;
  font-size: 20px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  font-style: normal;
}

.lcd-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.lcd-body {
  padding: 6px 0 8px;
  font-size: 14px;
  line-height: 1.6;
  color: #303133;
}

.lcd-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.lcd-btn-cancel {
  border-radius: 8px;
  background: #fff;
  border-color: #dcdfe6;
  color: #303133;
}

.lcd-btn-ok {
  border-radius: 8px;
  border-radius: 4px;
  background-color: #0052d9 !important;
  border-color: #0052d9 !important;
}

.lcd-btn-transfer {
  border-radius: 8px;
  background: #fff34d !important;
  border-color: #fff34d !important;
  color: #303133 !important;
  padding-left: 14px;
  padding-right: 14px;
}

.lcd-btn-transfer-help {
  margin-left: 6px;
  font-size: 14px;
  vertical-align: middle;
}
</style>

<style lang="scss">
.logout-confirm-dialog-shell.el-dialog {
  border-radius: 14px;
}

.logout-confirm-dialog-shell .el-dialog__header {
  padding: 20px 20px 10px;
}

.logout-confirm-dialog-shell .el-dialog__body {
  padding: 0 20px 12px;
}

.logout-confirm-dialog-shell .el-dialog__footer {
  padding: 8px 20px 18px;
}

/* tooltip 箭头与设计稿浅色气泡 */
.lcd-transfer-tooltip.el-tooltip__popper.is-light {
  border: 1px solid #ebeef5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
</style>
